import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthContext } from '../../../contexts/AuthContext';
import { identityRefreshTokenStart } from '../../../redux/identity/identitySlice';
import { RootState } from '../../../redux/store';
import { getCookieCustom } from '../../../utils/cookies';
import { saveLastConnectionKey } from '../../../utils/authTokens';
import { TextField, MenuItem } from '@mui/material';

// const getDefaultDatabaseFromLoginUser = (
//  loginUser: ReturnType<typeof useAuthContext>['loginUser'],
// ): UserDatabasesDTO | null => {
//  if (!loginUser?.currentlyActiveDb) {
//   return null;
//  }
//  const currentDb = loginUser.databases?.find((databaseItem) =>
//   databaseItem.startsWith(`${loginUser.currentlyActiveDb}:`),
//  );
//  const clientName = currentDb ? currentDb.split(':').slice(1).join(':') : '';
//  return {
//   Id: Number(loginUser.currentlyActiveDb),
//   Client: clientName,
//  };
// };

const DatabaseSelector = () => {
 const dispatch = useDispatch();
 const { loginUser, databases } = useAuthContext();
 const { success } = useSelector((state: RootState) => state.identity);
 const [selectedDatabase, setSelectedDatabase] = useState<string>(
  loginUser?.currentlyActiveDb || '',
 );

 useEffect(() => {
  if (databases && databases.length > 0) {
   setSelectedDatabase(loginUser?.currentlyActiveDb || '');
  }
 }, [databases]);

 useEffect(() => {
  if (success?.identityRefreshToken) {
   console.log('refresh token success');
   const url = new URL(window.location.href);
   url.searchParams.delete('id');
   window.location.href = url.toString();
  }
 }, [success]);

 const handleDatabaseChange = (value: string) => {
  setSelectedDatabase(value);
  saveLastConnectionKey(value);
  dispatch(
   identityRefreshTokenStart({
    access_token: getCookieCustom('access_token'),
    refresh_token: getCookieCustom('refresh_token'),
    connectionKey: Number(value),
   }),
  );
 };

 if (databases && databases.length === 0) {
  return null;
 }

 return (
  <TextField
   fullWidth
   select
   size="small"
   value={selectedDatabase}
   onChange={(event) => handleDatabaseChange(event.target.value)}
   sx={{ mb: '20px' }}
  >
   {databases?.map((database) => (
    <MenuItem key={database.Id} value={database.Id}>
     {database.Client}
    </MenuItem>
   ))}
  </TextField>
 );
};

export default DatabaseSelector;
